import { returnFormattedDate } from "@/lib/globalFormatterHelper";
import {
  ITicketFieldsProps,
  TICKET_EMPTY_VALUE,
} from "../helper/ticketSharedHelper";
import TicketRow from "../ticketFields/TicketRow";
import TicketTenorDateInput from "../ticketFields/TicketTenorDateInput";
import { useRepoTicket } from "./useRepoTicket";
import { TicketInstrument } from "@/store/tradeFromScratchStore";
import { returnSettlementHolidayCalendars } from "../helper/holidayCalendarsHelper";

// The repo term and collateral context. Becomes the Trade Creation Security Details
// panel content.
const RepoDetailFields = ({ ticketId, highlightedKeys }: ITicketFieldsProps) => {
  const { ticket, updateRepoTicket, collateral, dateIssue, requiredKeys } =
    useRepoTicket(ticketId);

  const isMissing = (key: string) => !!highlightedKeys?.has(key);

  return (
    <div
      data-testid="RepoDetailFieldsContainer"
      id="RepoDetailFieldsContainer"
      className="flex flex-col gap-2"
    >
      {/* Tenor counts from the start date (LQC-2975). */}
      <TicketRow
        label="Termination Date"
        testId="RepoTicketTerminationDateRow"
        isHighlighted={isMissing("terminationDate")}
        isRequired={requiredKeys.has("terminationDate")}
        error={dateIssue?.key === "terminationDate" ? dateIssue.message : ""}
      >
        <TicketTenorDateInput
          testId="RepoTicketTerminationDateInput"
          holidayCalendars={returnSettlementHolidayCalendars(TicketInstrument.Repo, ticket)}
          value={ticket.terminationDate}
          tenorStart={ticket.settlementDate}
          onChange={(terminationDate) => updateRepoTicket({ terminationDate })}
        />
      </TicketRow>

      <TicketRow label="Trade Date" testId="RepoTicketTradeDateRow">
        <div className="text-xs dark:text-gray-200">
          {ticket.tradeDate
            ? returnFormattedDate(ticket.tradeDate)
            : TICKET_EMPTY_VALUE}
        </div>
      </TicketRow>

      {/* Locked until the repo close requirement is finalised. */}
      <TicketRow label="Open / Close" testId="RepoTicketOpenCloseRow">
        <div className="text-xs dark:text-gray-200">{ticket.openClose}</div>
      </TicketRow>

      <TicketRow label="Collateral Ccy" testId="RepoTicketCurrencyRow">
        <div className="text-xs dark:text-gray-200">
          {collateral?.currency || TICKET_EMPTY_VALUE}
        </div>
      </TicketRow>

      <TicketRow label="Collateral Maturity" testId="RepoTicketMaturityRow">
        <div className="text-xs dark:text-gray-200">
          {collateral?.maturityDate
            ? returnFormattedDate(collateral.maturityDate)
            : TICKET_EMPTY_VALUE}
        </div>
      </TicketRow>
    </div>
  );
};

export default RepoDetailFields;
